const list = {
  // =================================================================================================================
  components(options) {
    if (options && options.boardId === 1007) {
      return [
        {
          'component': 'search-select-field',
          "label": '사업장명',
          "value": 'field',
          "query": {'f_id': 'fieldId', 'f_name': 'fieldName'},
        },
        {
          component: "search-start-end",
          label: "작성일",
          value: "date",
          query: { ss: "startDate", ee: "endDate" },
          options: {
            default: { sd: "", ed: "" },
          },
        },
        {
          component: "search-column-keyword",
          label: "검색조건",
          value: "column",
          query: { ck_t: "head", ck_k: "keyword" },
          options: { hiddenList: ["사업장명", "대상년월", "교육인원(대상/참석)", "교육일자", "작성일"] },
        },
      ]
    } else {
      return [
        {
          component: "search-start-end",
          label: "작성일",
          value: "date",
          query: { ss: "startDate", ee: "endDate" },
          options: {
            default: { sd: "", ed: "" },
          },
        },
        {
          component: "search-column-keyword",
          label: "검색조건",
          value: "column",
          query: { ck_t: "head", ck_k: "keyword" },
          options: { hiddenList: ["교육인원(대상/참석)", "교육일자", "작성일"] },
        },
      ];
    }
  },
  getConditions: (nav, options) => {
    const conditions = [];
    const search = nav.value;
    const boardId = options ? options.boardId : 0;

    if (boardId === 1007) {
      // 사업장명
      if (search.field && search.field.fieldId) {
        conditions.push({key: 'body.stdInfo.field_id', operator: '=', value: search.field.fieldId})
      }
    }
    //  작성일
    if (search.date) {
      conditions.push({ key: "created_at", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "created_at", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      { name: "사업장명", key: "body.stdInfo.field_name" },
      { name: "팀(업체)명", key: "body.stdInfo.section" },
      { name: "교육인원(대상/참석)", key: "body.교육인원대상자수" },
      { name: "교육구분", key: "body.교육구분" },
      { name: "교육일자", key: "body.교육진행[0].교육일자" },
      { name: "작성자", key: "body.stdInfo.writer_name" },
      { name: "작성일", key: "created_at" },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0:
        return func.getContent(value).stdInfo.field_name; // 사업장명
      case 1: {
        const 팀업체 = func.getContent(value).팀업체;
        console.log(팀업체);
        if (팀업체 && 팀업체.length > 0) {
          return 팀업체.map(item => {
            const parts = [];
            if (item.공장 && item.공장.value) parts.push(item.공장.value);
            if (item.팀1차 && item.팀1차.value) parts.push(item.팀1차.value);
            if (item.팀2차 && item.팀2차.value) parts.push(item.팀2차.value);
            return parts.join("-");
          }).join(" / "); // 팀(업체)명
        } else {
          return func.getContent(value).stdInfo.section; // 팀(업체)명
        }
      }
      case 2:
        return `${func.getContent(value).교육인원대상자수} / ${func.getContent(value).교육인원참석자수}`; // 교육인원(대상/참석)
      case 3:
        return func.getContent(value).교육구분; // 교육구분
      case 4:
        return func.getContent(value).교육진행[0].교육일자; // 교육일자
      case 5:
        return func.getContent(value).stdInfo.writer_name // 작성자
      case 6:
        return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
